<template>
  <div class="client-code" :style="styles">
    {{ code }}
  </div>
</template>

<script>
  export default {
    name: 'client-code',
    props: {
      code: { default: '---' },
      seed: { default: '---' },
      textColour: { default: null }
    },
    methods: {
      codeToColour (str) {
        // From: http://jsfiddle.net/sUK45/
        var hash = 0
        for (let i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash)
        }
        var colour = '#'
        for (let i = 0; i < 3; i++) {
          var value = (hash >> (i * 8)) & 0xFF
          colour += ('00' + value.toString(16)).substr(-2)
        }
        return colour
      },
      invertColor (hex) {
        // From: https://stackoverflow.com/questions/35969656/how-can-i-generate-the-opposite-color-according-to-current-color
        if (hex.indexOf('#') === 0) {
          hex = hex.slice(1)
        }
        // convert 3-digit hex to 6-digits.
        if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
        }
        if (hex.length !== 6) {
          throw new Error('Invalid HEX color.')
        }
        // invert color components
        let r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16)
        let g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16)
        let b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16)
        // pad each with zeros and return
        return '#' + this.padZero(r) + this.padZero(g) + this.padZero(b)
      },

      padZero (str, len) {
        len = len || 2
        var zeros = new Array(len).join('0')
        return (zeros + str).slice(-len)
      }
    },
    computed: {
      styles () {
        let textColour = this.textColour || this.codeToColour(this.seed)
        let bgColour = this.invertColor(textColour)

        return {
          'color': this.textColour ? textColour : null,
          'background-color': bgColour
        }
      }
    }
  }
</script>
<style lang="less" rel="stylesheet/less">
  .client-code {
    width: 36px;
    height: 36px;
    border-radius: 18px;
    font-size: 10px;
    line-height: 36px;
    text-align: center;
    font-weight: 900;
    margin-right: 15px;
    color: #FFF;
    letter-spacing: -0.01em;

  }
</style>
